<template>
	<div class="nav-top-wrap">
		<div @mouseleave="handleHide">
			<el-scrollbar>
				<ul class="menu-wrap">
					<!-- <li>
						<div @click="toHome" @mouseover="handleHide()"  class="menu-home" :class="[activePath=='/productHome'?'active-menu':'']">
							首页</div>
					</li> -->
					<li v-for="(item,index) in navList" @mouseover="showToggle(item,index)">
						<div @click="changeItem(item)" class="menu" :class="[activePath==item.linkRoute||(item.list&&item.isShowMenuDrop)?'active-menu':'']">
							{{item.columnName}}
							<!-- <i class="el-icon-arrow-down" v-show="item.list&&item.list.length>0"></i> -->
						</div>
					</li>
				</ul>
			</el-scrollbar>
			<div class="mask"  v-for="(item, index) in navList"  v-if="item.list&&item.list.length>0&&item.isShowMenuDrop">
				<div class="menu-dropdown">
					<div  @mouseleave="handleHide" @mouseover="dropdownOver(item)">
						<div class="dropdown-list" v-if="menuIndex==index">
							<div class="dropdown-list-l">
								<ul>
									<li @click="toDetail(subItem)" @mouseover="subMenuOver(subIndex)" :class="[menuSub2Index==subIndex?'active':'']" v-for="(subItem, subIndex) in item.list">
										<span>{{subItem.columnName}}</span>
										<span class="line"></span>
									</li>
								</ul>
							</div>
							<div class="dropdown-list-r">
								<el-scrollbar style="height: 100%;">
									<div class="product-all"><a href="javascript:;" @click="changeItem(navList[0].list[0])">查看所有产品 ></a></div>
									<div class="product-list" v-for="subItem2 in item.list[menuSub2Index].list">
										<div v-if="subItem2.list.length>0" @click="toDetail(subItem2)" class="subItem2-title">
											<i>{{subItem2.columnName}}</i>
										</div>
										<ul v-else>
											<li @click="toDetail(subItem2)">
												<img class="icon-url" :src="subItem2.iconUrl"/>
												<i>{{subItem2.columnName}}</i>
												<div class="desc">{{subItem2.columnDesc}}</div>
											</li>
										</ul>
										<ul v-if="subItem2.list.length>0">
											<li @click="toDetail(subItem3)" v-for="subItem3 in subItem2.list">
												<img class="icon-url" :src="subItem3.iconUrl"/>
												<i>{{subItem3.columnName}}</i>
												<div class="desc">{{subItem3.columnDesc}}</div>
											</li>
										</ul>
										<!-- <div v-if="subItem2.list.length>0">
											<div @click="toDetail(subItem2)" class="subItem2-title">
												<i>{{subItem2.columnName}}</i>
											</div>
											<ul>
												<li @click="toDetail(subItem3)" v-for="subItem3 in subItem2.list">
													<img class="icon-url" :src="subItem3.iconUrl"/>
													<i>{{subItem3.columnName}}</i>
													<div class="desc">{{subItem3.columnDesc}}</div>
												</li>
											</ul>
										</div>
										<div v-else>
											<ul>
												<li @click="toDetail(subItem2)" v-for="subItem2 in item.list">
													<img class="icon-url" :src="subItem2.iconUrl"/>
													<i>{{subItem2.columnName}}</i>
													<div class="desc">{{subItem2.columnDesc}}</div>
												</li>
											</ul>
										</div> -->
									</div>
								</el-scrollbar>
							</div>
						</div>
					</div>
					
				</div>
			</div>
			
		</div>
	</div>
</template>

<script>
	import qs from 'qs'
	import { post, ajaxParam} from '@/units/request.js'
	export default {
		name: 'navTop',
		data() {
			return {
				activePath: '/productHome',
				navList: [],
				isShowSub: false,
				menuIndex: 0,
				menuSub2Index: 0,
			}
		},
		mounted() {
			
			this.activePath = this.$route.fullPath
			this.navList.forEach((item,index)=>{
				if(item.linkRoute==this.activePath) {
					let nav = document.querySelectorAll('.menu')
					nav.forEach((item)=>{
						item.className = 'menu'
					})
					nav[index].className = 'menu active-menu'
				}
			})
		},
		watch: {
			$route(to, from) {
				let path = to.path
				if(path.indexOf('newsDetail')==1){
					this.activePath = '/news/'+this.$route.params.navId
				} else if(path.indexOf('videoDetail')==1){
					this.activePath = '/video/'+this.$route.params.navId
				} else {
					this.activePath = path
				}
				
				if(this.activePath=='/productHome') {
					let nav = document.querySelectorAll('.menu')
					let navHome = document.querySelectorAll('.menu-home')
					nav.forEach((item)=>{
						item.className = 'menu'
					})
					navHome[0].className='menu-home active-menu'
				}
			}
		},
		methods: {
			toDetail(item){
				//window.open(item.linkRoute)
				console.log(item)
				this.$router.push({
					path: item.linkRoute
				})
				this.handleHide()
			},
			subMenuOver(index){
				this.menuSub2Index = index
			},
			dropdownOver(item){
				item.isShowMenuDrop = true
			},
			showToggle(item,index) {
				this.navList.forEach(itemnav=>{
					itemnav.isShowMenuDrop = false
				})
				item.isShowMenuDrop = true
				this.menuIndex = index
				this.menuSub2Index = 0
			},
			handleHide() {
				this.navList.forEach(item=>{
					item.isShowMenuDrop = false
				})
			},
			//single_document：单篇文档类  document：文档类 video：视频类
			//download：下载类 news：动态新闻类 single_page：单页内容类  link：外链地址
			async getDataList() {
				let param = {}
				ajaxParam(param)
				// const res = await post('v1/column/getColumnTree', qs.stringify(param))
				const res = await post('v1/column/getColumnMapTree', qs.stringify(param))
				if (res.data.code == 200) {
					let list = res.data.list
					list.forEach((item)=>{
						item.isShowMenuDrop = false
					})
					this.navList = list
				} else {
					this.$message.error(res.data.msg)
				}
			},
			toHome() {
				let nav = document.querySelectorAll('.menu')
				nav.forEach(item=>{
					item.className = 'menu'
				})
				this.$router.push({
					path: '/productHome'
				})
			},
			handleOpen(item) {
				this.activePath = item.linkRoute
				this.$router.push({
					path: item.linkRoute
				})
			},
			changeItem(item) {
				console.log(item)
				if (item.typeCode == 'link') {
					window.open(item.linkUrl)
					return
				}
				if(item.linkRoute) {
					if(item.linkRoute=='#'){
						return
					} else {
						this.$router.push({
							path: item.linkRoute
						}, () => {})
					}
				}
			}
		},
		created() {
			this.getDataList()
		}
	}
</script>

<style scoped lang="less">
	.menu-wrap {
		display: flex;
		.menu,.menu-home {
			margin-left: 20px;
			padding: 12px 10px 10px;
			text-align: center;
			line-height: 32px;
			color: #323232;
			opacity: .8;
			border-bottom: 4px solid transparent;
			white-space: nowrap;
			cursor: pointer;
			font-size: 15px;
		}
		.menu:hover,.menu-home:hover,{
			opacity: 1;
			font-weight: bold;
			border-color: #DD0515;
			//font-size: 18px;
		}
		li {
			position: relative;
		}

		.active-menu {
			opacity: 1;
			font-weight: bold;
			border-color: #DD0515;
			//font-size: 18px;
		}
	}

	.nav-top-wrap {
		width: 100%;
		background: #fff;
	}

	.nav-top {
		display: flex;
		li {
			padding: 18px 0 16px;
			margin-left: 30px;
			line-height: 32px;
			color: #323232;
			opacity: .8;
			border-bottom: 4px solid transparent;
			cursor: pointer;
		}

		li.active {
			opacity: 1;
			font-weight: bold;
			border-color: #DD0515;
			font-size: 18px;
		}

		li.active a {
			color: #DE0515;
		}
	}
	.transform{
		transform: rotate(180deg) scale(.8);
	}
	.el-icon-arrow-down{
		transition: all .4s;
	}
	.menu-dropdown{
		position: absolute;
		right: 0;
		left: 0;
		top: 0;
		bottom: 100px;
		z-index: 9;
		//background: red;
		max-width: 1180px;
		margin: 0 auto;
		background: #fff;
		border-radius: 0 0 16px 16px;
		box-shadow: 0 4px 16px 0 rgba(0,0,0,.1);
		.dropdown-list{
			display: flex;
			justify-content: space-between;
			height: 100%;
			color: #595959;
			.dropdown-list-l{
				width: 203px;
				position: absolute;
				left: 0;
				top: 0;
				bottom: 0;
				overflow: auto;
				padding: 0;
				background: #fafafa;
				border-radius: 0 0 0 16px;
				border-right: 1px solid #dfe1e6;
				padding: 0 20px 20px 32px;
				ul{
					display: inline-block;
					margin-top: 30px;
					li{
						display: flex;
						flex-direction: column;
						padding-bottom: 6px;
						margin-bottom: 15px;
						border-bottom: 2px solid transparent;
						cursor: pointer;
					}
					li.active{
						border-bottom: 2px solid #323232;
						font-weight: bold;
						color: #323232;
					}
				}
			}
			.dropdown-list-r{
				flex: 1;
				position: absolute;
				left: 256px;
				top: 0;
				right: 0;
				bottom: 10px;
				padding: 30px 32px;
				overflow-x: hidden;
				.product-all{
					margin-bottom: 15px;
					font-size: 20px;
					line-height: 30px;
				}
				.product-all a:hover{
					text-decoration: underline;
					color: #323232;
				}
				.icon-url{
					width: 24px;
					height: 24px;
					border-radius: 5px;
				}
				.desc{
					font-size: 12px;
					color: #595959;
					display: -webkit-box;
					-webkit-box-orient: vertical;
					-webkit-line-clamp: 2;
					overflow: hidden;
				}
				i{
					padding:8px 0 5px;
					font-weight: bold;
					font-size: 13px;
					overflow: hidden;
					text-overflow: ellipsis;
					white-space: nowrap;
				}
				.product-list{
					.subItem2-title{
						display: flex;
						flex-direction: column;
						margin-bottom: 20px;
						cursor: pointer;
						span.title{
							display: block;
							width: 80%;
							padding-bottom: 5px;
							border-bottom: 1px solid #bfbfbf;
							font-weight: bold;
						}
					}
					.subItem2-title:hover i{
						text-decoration: underline;
					}
					ul{
						li{
							display: flex;
							flex-direction: column;
							width: 24%;
							cursor: pointer;
							padding: 12px 15px;
							margin-right: 1%;
							box-sizing: border-box;
						}
						li:hover{
							-webkit-box-shadow: 0 4px 12px 0 rgba(0,0,0,.1);
							box-shadow: 0 4px 12px 0 rgba(0,0,0,.1);
							border-radius: 8px;
						}
						li:hover i{
							text-decoration: underline;
						}
					}
				}
				
				ul{
					display: flex;
					flex-wrap: wrap;
					.subItem2-title{
						display: flex;
						flex-direction: column;
						margin-bottom: 20px;
						cursor: pointer;
						span.title{
							display: block;
							width: 80%;
							padding-bottom: 5px;
							border-bottom: 1px solid #bfbfbf;
							font-weight: bold;
						}
					}
					.subItem2-title:hover i{
						text-decoration: underline;
					}
					
					li{
						width: 25%;
						margin-bottom: 20px;
						ul{
							li{
								display: flex;
								flex-direction: column;
								width: 25%;
								cursor: pointer;
							}
							li:hover{
								-webkit-box-shadow: 0 4px 12px 0 rgba(0,0,0,.1);
								box-shadow: 0 4px 12px 0 rgba(0,0,0,.1);
							}
							li:hover i{
								text-decoration: underline;
							}
						}
					}
				}
			}
		}
	}
	.dropdown-list-r /deep/ .el-scrollbar__wrap{
		overflow-x: hidden;
	}
	.mask{
		left:0;
		right:0;
		bottom:0;
		top: 58px;
		position: fixed;
		-webkit-backdrop-filter: blur(6px);
		backdrop-filter: blur(6px);
		background: hsla(0,0%,100%,.2);
	}
	@media (max-width: 1280px) {
		.menu-dropdown{
			max-width: 1180px;
			.dropdown-list{
				.dropdown-list-r{
					.product-list{
						ul{
							li{
								width: 31.3%;
							}
						}
					}
				}
			}
		}
	}
	@media (max-width: 1776px) {
	    .menu-dropdown {
	        max-width:90%
	    }
	}
	
	@media (max-width: 1440px) {
	    .menu-dropdown {
	        max-width:100%
	    }
	}
</style>
